<template>
  <div class="dea-agency" v-on="$listeners">
    <div class="dea-agency__agency-data">
      <AgencyData
        :bottom-chips="bottomChips"
        :name="name"
        :phone="phone"
        :mail="mail"
        :address="address"
        :label="label"
        :chips="chips"
        :fax="fax"
        :note="note"
        :website="website"
        :drop-point-link="dropPointLink"
      />
    </div>
    <div v-if="details" class="dea-agency__cta-container">
      <Links
        :href="details"
        class-name="dea-links dea-links--target-color-blue-docenti dea-links--large"
        @[linkClickEvent]="$emit('open-modal')"
        >{{ ctaDetails }}</Links
      >
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";
import AgencyData from "./AgencyData";
/**
 * CardAgency
 */
export default {
  name: "CardAgency",

  components: { AgencyData, Links },
  props: {
    name: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
    mail: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    details: {
      type: String,
      default: "",
    },
    fax: {
      type: String,
      default: "",
    },
    note: {
      type: String,
      default: "",
    },
    ctaDetails: {
      type: String,
      default: "Vedi dettagli",
    },
    chips: {
      type: Array,
      default: () => [],
    },
    website: {
      type: String,
      default: "",
    },
    dropPointLink: {
      type: String,
      default: "",
    },
    bottomChips: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    linkClickEvent() {
      if (this.details === "#") return "click";
      return "";
    },
  },
};
</script>
